import React, { Component } from 'react';
import { TextoDados } from '../../components/Texto/Dados';
import InputValor from '../../components/Inputs/Valor';
import AlertGeral from '../../components/Alert/Geral';
import { connect } from 'react-redux';
import * as actions from '../../actions/configuracoes';

var timer;

class ConfigWhatsApp extends Component {

	generateStateConfiguracao = (props) => ({
		whatsAppNumber: props.loja ? (props.loja.whatsAppNumber || "") : ""
	});

	state = {
		...this.generateStateConfiguracao(this.props),
		aviso: null,
		erros: {}
	}

	getConfiguracao(props){
		const { usuario } = props;
		if(!usuario) return null;
		this.props.getConfiguracao(usuario.loja);
	}

	componentDidMount(){
		this.getConfiguracao(this.props);
	}
	
	componentDidUpdate(prevProps){
		if(!prevProps.usuario && this.props.usuario) this.getConfiguracao(this.props);
		if(!prevProps.loja && this.props.loja) this.setState(this.generateStateConfiguracao(this.props));
	}

	validate(){
		const { whatsAppNumber } = this.state;
		const erros = {};

		if(!whatsAppNumber) erros.whatsAppNumber = "Preencha aqui com o número do WhatsApp";

		this.setState({ erros });
		return !(Object.keys(erros).length > 0);
	}

	updateConfigs = () => {
		const { usuario } = this.props;
		if(!usuario || !this.validate()) return null;

		clearTimeout(timer)
		
		timer = setTimeout(() => {
			this.props.updateWhatsAppNumber(this.state.whatsAppNumber, usuario.loja, (error) => {
				this.setState({
					aviso: {
						status: !error,
						msg: error ? error.message : "Número do WhatsApp atualizado com sucesso!"
					}
				});
				error && console.log(error)
			});
			clearTimeout(timer)
		}, 500)

		return
	}

	handleSubmit = (field, value) => {
		this.setState({ [field]: value }, () => this.validate());
		this.updateConfigs()
	}

	render(){
		const { whatsAppNumber, erros, aviso } = this.state;
		return (
			<div className="config-whatsapp">
				<AlertGeral aviso={aviso} />
				<div className="item-section">
					<TextoDados chave="Número do WhatsApp" valor={
						<InputValor 
							noStyle 
							value={whatsAppNumber} 
							name="whatsAppNumber" 
							erro={erros.whatsAppNumber} 
							handleSubmit={(valor) => this.handleSubmit( "whatsAppNumber", valor )} 
						/>
					} />
					<p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
						<strong>Formato:</strong> Digite apenas números, incluindo código do país (ex: 5521971060671)
					</p>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	loja: state.configuracao.loja,
	usuario: state.auth.usuario
});

export default connect(mapStateToProps, actions)(ConfigWhatsApp);

